export interface ArticleDetail {
  id: number;
  title: string;
  author: string;
  rating: number;
  category: string;
  categorySlug: string;
  tags: string[];
  status: string;
  chapters: number;
  updateTime: string;
  description: string;
  longDescription: string;
  coverImage: string;
  heroImage: string;
}

export const articleDetails: Record<number, ArticleDetail> = {
  1: {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / Jang Sung-rak',
    rating: 9.7,
    category: '动作',
    categorySlug: 'dong-zuo',
    tags: ['奇幻', '热血', '系统', '战斗'],
    status: '已完结',
    chapters: 179,
    updateTime: '2026-06-15',
    description: '在一个连接异次元的"门"出现的世界，觉醒者猎人程肖宇从"最弱猎人"一步步进化为最强存在。精美的画风与爽快的战斗场面，让这部作品成为全球现象级韩漫。',
    longDescription: '十年前，世界出现了连接异次元的"门"，随之觉醒了拥有超能力的"猎人"。程肖宇作为最低等级的E级猎人，在被称为"人类最弱兵器"的同时，为了母亲的治疗费和妹妹的学费，不得不冒着生命危险进入地下城。某天，他在一次几乎全军覆没的双重地下城任务中，濒死之际获得了一个神秘的系统——"玩家系统"。从此，他可以像游戏中一样通过完成任务来提升等级和能力。从一个被所有人看不起的最弱猎人，到独自一人能够清空S级地下城的顶级强者，程肖宇的升级之路就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Solo%20leveling%20manhwa%20detailed%20cover%2C%20dark%20fantasy%20warrior%20with%20glowing%20eyes%2C%20epic%20battle%20pose%2C%20Korean%20webtoon%20art%20style%2C%20warm%20dark%20dramatic%20lighting&width=500&height=700&seq=article-cover-01&orientation=portrait',
    heroImage: 'https://readdy.ai/api/search-image?query=Solo%20leveling%20manhwa%20wide%20banner%2C%20dark%20fantasy%20warrior%20silhouette%20against%20epic%20battlefield%2C%20dramatic%20warm%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20cinematic%20composition&width=1800&height=900&seq=article-hero-01&orientation=landscape',
  },
  2: {
    id: 2,
    title: '女神降临',
    author: 'Yaongyi',
    rating: 9.5,
    category: '恋爱',
    categorySlug: 'lian-ai',
    tags: ['校园', '美妆', '喜剧', '三角恋'],
    status: '已完结',
    chapters: 226,
    updateTime: '2026-06-28',
    description: '因外貌自卑的女孩通过化妆技巧蜕变为校园女神，在两个完美男神之间展开了一段甜蜜又纠结的三角恋。画风绝美，剧情治愈又搞笑。',
    longDescription: '林周京从小因为外貌被人嘲笑和欺凌，在经历了痛苦的校园生活后，她决定通过YouTube学习化妆技巧来改变自己。没想到她的化妆技术竟然如此出色，转学后以"女神"的形象出现在新学校，瞬间成为全校瞩目的焦点。然而，她必须小心翼翼地隐藏素颜的秘密。在这个新学校里，她遇到了两个完全不同的男生——一个是外表冷酷内心温柔的学霸李修豪，另一个是阳光帅气的校园偶像韩书俊。当她在这两个男生之间摇摆不定时，还要时刻担心自己的秘密被揭穿。',
    coverImage: 'https://readdy.ai/api/search-image?query=True%20Beauty%20manhwa%20detailed%20cover%2C%20beautiful%20Korean%20girl%20makeup%20transformation%2C%20soft%20romantic%2C%20Korean%20webtoon%20style%2C%20warm%20pastel%20tones&width=500&height=700&seq=article-cover-02&orientation=portrait',
    heroImage: 'https://readdy.ai/api/search-image?query=True%20Beauty%20manhwa%20wide%20banner%2C%20romantic%20school%20scene%2C%20beautiful%20girl%20with%20makeup%2C%20soft%20dreamy%20atmosphere%2C%20Korean%20webtoon%20style%2C%20warm%20gentle%20lighting&width=1800&height=900&seq=article-hero-02&orientation=landscape',
  },
  3: {
    id: 3,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    rating: 9.6,
    category: '奇幻',
    categorySlug: 'qi-huan',
    tags: ['末世', '系统', '智斗', '生存'],
    status: '连载中',
    chapters: 210,
    updateTime: '2026-07-05',
    description: '金独子是唯一读完长达3149话网络小说《在灭亡的世界中生存的三种方法》的人，当小说中的末日场景在现实中上演，他凭借全知视角在这末世中艰难求生。',
    longDescription: '金独子是一个普通的上班族，他唯一的爱好就是阅读网络小说。十年来，他一直是《在灭亡的世界中生存的三种方法》这部超长连载小说的唯一忠实读者。当这部小说终于迎来完结的那一天，金独子收到了作者发来的神秘邮件。紧接着，小说中描绘的末日场景竟然在现实中开始上演——怪物降临、系统提示出现、身边的人开始死亡。作为一个知晓整个故事走向的"全知读者"，金独子必须利用他对剧情的了解，在这残酷的末世中活下去，并试图改变那些注定的悲剧结局。',
    coverImage: 'https://readdy.ai/api/search-image?query=Omniscient%20reader%20manhwa%20detailed%20cover%2C%20apocalyptic%20fantasy%2C%20mysterious%20protagonist%2C%20Korean%20webtoon%20style%2C%20dark%20warm%20tones&width=500&height=700&seq=article-cover-03&orientation=portrait',
    heroImage: 'https://readdy.ai/api/search-image?query=Omniscient%20reader%20wide%20banner%2C%20apocalyptic%20fantasy%20cityscape%2C%20dramatic%20cosmic%20elements%2C%20Korean%20webtoon%20style%2C%20dark%20warm%20lighting&width=1800&height=900&seq=article-hero-03&orientation=landscape',
  },
  4: {
    id: 4,
    title: '公爵的契约未婚妻',
    author: 'Milcha / Whale',
    rating: 9.3,
    category: '恋爱',
    categorySlug: 'lian-ai',
    tags: ['穿越', '宫廷', '契约', '甜宠'],
    status: '连载中',
    chapters: 158,
    updateTime: '2026-07-03',
    description: '穿越成为小说中即将被抛弃的配角，为了活下去，她向冷血公爵提出了契约婚约。一场各取所需的交易，却意外擦出爱的火花。',
    longDescription: '普通大学生朴敏雅某天醒来发现自己穿越进了正在追的言情小说中，成为了男主角的未婚妻——一个注定被抛弃、下场凄惨的配角角色。为了改变悲惨的命运，她决定主动出击，找到了小说中最令人畏惧的人物——被称为"北方之狼"的温特公爵。她向他提出了一桩契约婚约：她帮助他摆脱皇室的联姻压力，他保护她不被原未婚夫的家族迫害。公爵出人意料地答应了。然而，在这场原本各取所需的交易中，两个人都渐渐发现自己对对方产生了超出契约的情感。',
    coverImage: 'https://readdy.ai/api/search-image?query=Romance%20fantasy%20manhwa%20detailed%20cover%2C%20elegant%20duke%20and%20lady%20royal%2C%20Korean%20webtoon%20style%2C%20warm%20golden%20light&width=500&height=700&seq=article-cover-04&orientation=portrait',
    heroImage: 'https://readdy.ai/api/search-image?query=Romance%20fantasy%20wide%20banner%2C%20elegant%20royal%20couple%20in%20palace%2C%20lavish%20interior%2C%20Korean%20webtoon%20style%2C%20warm%20golden%20atmosphere&width=1800&height=900&seq=article-hero-04&orientation=landscape',
  },
  5: {
    id: 5,
    title: '恶女是提线木偶',
    author: 'Hanirim / Manggle',
    rating: 9.4,
    category: '剧情',
    categorySlug: 'ju-qing',
    tags: ['重生', '宫廷', '权谋', '复仇'],
    status: '连载中',
    chapters: 132,
    updateTime: '2026-07-04',
    description: '被最信任的人背叛而死，重生归来后的帝国皇女凯耶娜决心不再做任何人的提线木偶，她要亲手掌控自己的命运。',
    longDescription: '凯耶娜是帝国的第一皇女，她聪慧、美丽，却一直活在别人的操纵之下。她的父皇将她视为政治联姻的筹码，她的未婚夫只觊觎她的皇位继承权，她最信任的侍女更是暗中给她下毒。当她发现自己被身边所有人背叛，最终含恨而死时，她发誓若有来生，绝不再做任何人手中的提线木偶。命运给了她第二次机会——她重生回到了三年前，一切悲剧尚未开始的时候。带着前世的记忆和痛苦，凯耶娜开始了她的复仇和夺权之路。她将用自己的方式，让所有背叛她的人付出代价。',
    coverImage: 'https://readdy.ai/api/search-image?query=Villainess%20manhwa%20detailed%20cover%2C%20dark%20princess%20palace%2C%20dramatic%2C%20Korean%20webtoon%20style%2C%20rich%20warm%20colors&width=500&height=700&seq=article-cover-05&orientation=portrait',
    heroImage: 'https://readdy.ai/api/search-image?query=Villainess%20manhwa%20wide%20banner%2C%20elegant%20dark%20princess%20in%20royal%20palace%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20style%2C%20rich%20warm%20atmosphere&width=1800&height=900&seq=article-hero-05&orientation=landscape',
  },
  6: {
    id: 6,
    title: '剑尊归来',
    author: 'Biga / LICO',
    rating: 9.8,
    category: '动作',
    categorySlug: 'dong-zuo',
    tags: ['武侠', '重生', '热血', '修真'],
    status: '连载中',
    chapters: 186,
    updateTime: '2026-07-06',
    description: '一代剑尊在修炼巅峰陨落后重生到现代，以无敌剑术横扫各路强者。华丽的剑技与热血的战斗，让人热血沸腾。',
    longDescription: '陈剑云曾是修真界的传奇人物——一代剑尊，以无上剑术冠绝天下。然而在渡劫飞升之际，遭挚友背叛，身死道消。当他再次睁开眼睛时，发现自己重生到了一个完全陌生的现代世界。这个世界灵气稀薄，修真者几乎绝迹，但武道传承依然存在。凭借前世对剑道的至高领悟，陈剑云在这个现代武道世界中如鱼得水。他以无敌之姿横扫各路强者，一步步重新踏上巅峰，同时也逐渐揭开了自己重生背后的惊天秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Martial%20arts%20manhwa%20detailed%20cover%2C%20sword%20master%20dynamic%2C%20Korean%20webtoon%20style%2C%20warm%20fiery%20tones&width=500&height=700&seq=article-cover-06&orientation=portrait',
    heroImage: 'https://readdy.ai/api/search-image?query=Martial%20arts%20manhwa%20wide%20banner%2C%20sword%20master%20epic%20battle%2C%20dynamic%20energy%2C%20Korean%20webtoon%20style%2C%20warm%20dramatic%20lighting&width=1800&height=900&seq=article-hero-06&orientation=landscape',
  },
};

export const articleComments = [
  {
    id: 1,
    userName: '漫画迷小月',
    userAvatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%2C%20soft%20pastel%2C%20simple%20background%2C%20Korean%20webtoon%20style&width=80&height=80&seq=cmt-avatar-01&orientation=squarish',
    rating: 5,
    title: '这部真的太绝了',
    content: '一口气追完了全部章节，根本停不下来！剧情节奏把控得特别好，每一章都有新的惊喜。画风也是顶级水平，人物表情超级细腻。强烈推荐给还没看过的朋友！',
    time: '2026年7月5日',
  },
  {
    id: 2,
    userName: '热血漫魂',
    userAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20cool%20guy%20avatar%2C%20confident%2C%20simple%20background%2C%20Korean%20webtoon%20style&width=80&height=80&seq=cmt-avatar-02&orientation=squarish',
    rating: 5,
    title: '战斗场面太燃了',
    content: '每场战斗都画得特别精彩，分镜流畅度一流。下拉式阅读的方式完美展现了打斗的连贯性，比翻页式阅读爽太多了。51漫画网的阅读体验真的没话说！',
    time: '2026年7月4日',
  },
  {
    id: 3,
    userName: '熬夜看漫',
    userAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20woman%20avatar%2C%20warm%20smile%2C%20simple%20background%2C%20Korean%20webtoon%20style&width=80&height=80&seq=cmt-avatar-03&orientation=squarish',
    rating: 4,
    title: '画质清晰，阅读流畅',
    content: '在51漫画网看这部漫画已经几个月了，画质一直很清晰，没有删减内容。下拉式阅读真的比传统翻页方便太多了，单手就能操作，上班摸鱼神器哈哈。',
    time: '2026年7月3日',
  },
  {
    id: 4,
    userName: '漫无止境',
    userAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20gentle%20office%20worker%20avatar%2C%20simple%20background%2C%20Korean%20webtoon%20style&width=80&height=80&seq=cmt-avatar-04&orientation=squarish',
    rating: 5,
    title: '入坑不亏系列',
    content: '朋友推荐来看的，一开始还担心画风不是我的菜，结果看了三话就彻底上头了。现在每天都要来刷更新，成为了我的每日必做事项。',
    time: '2026年7月2日',
  },
  {
    id: 5,
    userName: '冷月如霜',
    userAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20gentle%20girl%20avatar%2C%20soft%20expression%2C%20simple%20background%2C%20Korean%20webtoon%20style&width=80&height=80&seq=cmt-avatar-05&orientation=squarish',
    rating: 5,
    title: '剧情深度超出预期',
    content: '原本以为只是爽文类型的漫画，没想到剧情深度远超预期。作者对人物心理的刻画非常细腻，每个角色的动机都很合理。这种质量的韩漫免费看真的太难得了。',
    time: '2026年7月1日',
  },
  {
    id: 6,
    userName: '二次元阿杰',
    userAvatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20boy%20portrait%20avatar%2C%20cool%20look%2C%20simple%20background%2C%20Korean%20webtoon%20style&width=80&height=80&seq=cmt-avatar-06&orientation=squarish',
    rating: 4,
    title: '更新速度令人满意',
    content: '作为追更党，最关心的就是更新速度。51漫画网的更新跟进非常及时，基本和韩国同步。画质也一直保持高水平，无删减阅读体验拉满。',
    time: '2026年6月30日',
  },
];

export const relatedComics = [
  { id: 4, title: '公爵的契约未婚妻', author: 'Milcha', rating: 9.3, image: 'https://readdy.ai/api/search-image?query=Romance%20fantasy%20manhwa%20cover%2C%20duke%20and%20lady%2C%20Korean%20webtoon%20style%2C%20warm%20golden%20light&width=300&height=420&seq=related-comic-01&orientation=portrait' },
  { id: 5, title: '恶女是提线木偶', author: 'Hanirim', rating: 9.4, image: 'https://readdy.ai/api/search-image?query=Villainess%20manhwa%20cover%2C%20dark%20princess%2C%20Korean%20webtoon%20style%2C%20rich%20warm%20colors&width=300&height=420&seq=related-comic-02&orientation=portrait' },
  { id: 6, title: '剑尊归来', author: 'Biga', rating: 9.8, image: 'https://readdy.ai/api/search-image?query=Martial%20arts%20manhwa%20cover%2C%20sword%20master%2C%20Korean%20webtoon%20style%2C%20warm%20fiery%20tones&width=300&height=420&seq=related-comic-03&orientation=portrait' },
  { id: 3, title: '全知读者视角', author: 'sing N song', rating: 9.6, image: 'https://readdy.ai/api/search-image?query=Omniscient%20reader%20manhwa%20cover%2C%20apocalyptic%2C%20Korean%20webtoon%20style%2C%20dark%20warm%20tones&width=300&height=420&seq=related-comic-04&orientation=portrait' },
];

export const articleFAQs = [
  {
    question: '什么是下拉式漫画阅读？',
    answer: '下拉式阅读是一种创新的漫画浏览方式，您无需翻页，只需向下滚动即可连续阅读漫画内容。这种方式完美适配移动端和桌面端，让阅读体验更加流畅自然，不会被打断。51漫画网的所有漫画均支持下拉式阅读。',
  },
  {
    question: '51漫画网的漫画是否有删减？',
    answer: '51漫画网承诺所有漫画内容均为无删减版本，我们致力于为读者提供最完整、最原汁原味的韩漫阅读体验。每一部漫画都与原作保持一致，不会有任何内容被修改或移除。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的分类浏览找到感兴趣的题材，也可以在搜索框中输入漫画名称或作者名进行查找。我们还提供了排行榜和最新更新栏目，帮助您发现热门和新上架的漫画作品。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '51漫画网与韩国更新保持同步，大部分连载漫画每周更新1-2话。我们会在第一时间更新最新的章节，确保读者能够及时追更。您还可以通过邮箱订阅功能，第一时间收到更新通知。',
  },
];